import React from 'react';
import { WagmiProvider as WagmiProviderOriginal, createConfig, http } from 'wagmi';
import { mainnet, polygon, arbitrum, optimism, base, bsc, avalanche, linea } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { injected } from 'wagmi/connectors';

// Create wagmi config with MetaMask and Phantom
const config = createConfig({
  chains: [mainnet, polygon, arbitrum, optimism, base, bsc, avalanche, linea],
  connectors: [
    injected({ target: 'metaMask' }), // MetaMask
    injected({ target: 'phantom' }), // Phantom
  ],
  transports: {
    [mainnet.id]: http(),
    [polygon.id]: http(),
    [arbitrum.id]: http(),
    [optimism.id]: http(),
    [base.id]: http(),
    [bsc.id]: http(),
    [avalanche.id]: http(),
    [linea.id]: http(),
  },
});

// Create query client for React Query with error handling
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

interface WagmiProviderProps {
  children: React.ReactNode;
}

export function WagmiProvider({ children }: WagmiProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <WagmiProviderOriginal config={config}>
        {children}
      </WagmiProviderOriginal>
    </QueryClientProvider>
  );
}
